import React from "react";
import Icon from "@ant-design/icons";


const StaffClockSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M24,5.3C13.5,5.3,4.9,13.9,4.9,24.4s8.6,19.1,19.1,19.1,19.1-8.6,19.1-19.1S34.5,5.3,24,5.3ZM24,41c-9.2,0-16.6-7.5-16.6-16.6S14.8,7.8,24,7.8s16.6,7.5,16.6,16.6-7.5,16.6-16.6,16.6Z" />
        <path d="M33.8,29l-8.7-5.6v-12.6c0-.7-.6-1.2-1.2-1.2s-1.2.6-1.2,1.2v13.3c0,.4.2.8.6,1.1l9.3,6c.2.1.4.2.7.2.4,0,.8-.2,1.1-.6.4-.6.2-1.4-.4-1.7Z" />
    </svg>
);

const StaffClockIcon = (props) => <Icon { ...props } component={ StaffClockSvg } />;

export default StaffClockIcon;
